import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { REV_PASH } from '../../constants';
import { RevPashQuery } from '../queries';

export class RevPashCalculator extends Calculator {
  kpiType = REV_PASH

  async calculateKPI() {
    const currentResponse = await this.executeUncubeQuery(RevPashQuery, this.currentPeriod);
    let props;
    const numberOfDinersPointOfSale = currentResponse.data.result[0][2] / currentResponse.data.result[0][3];
    const hours = currentResponse.data.result[0][0];
    const dinerHours = numberOfDinersPointOfSale * hours;
    if (this.previousPeriod) {
      const previousResponse = await this.executeUncubeQuery(RevPashQuery, this.previousPeriod);
      const previousHours = previousResponse.data.result[0][0];
      const prevNumberOfDinersOfSale = previousResponse.data.result[0][2] / previousResponse.data.result[0][3];
      const prevDinerHours = previousHours * prevNumberOfDinersOfSale;
      props = this.getData((currentResponse.data.result[0][1] / dinerHours), (previousResponse.data.result[0][1] / prevDinerHours));
    } else props = this.getDataIfNoPreviousPeriod(currentResponse.data.result[0][1] / dinerHours);
    return this.getModelToInstance(props);
  }

  getValueOfKpi(rawKpi) {
    if (!Number.isNaN(rawKpi) && Number.isFinite(rawKpi)) {
      return Math.trunc(rawKpi * 100) / 100;
    }
    return 0;
  }
}
